import { put, takeLatest, all, select } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import MOActions, { moActionTypes } from '../actions/moActions';
import MOServices from '../services/moServices';

/**
 * @param action
 */
function* _createMO(action) {
  try {
    yield put(MOActions.createMOLoading(true));
    const mo = yield MOServices.createMO(action.payload);
    if (mo.success) {
      yield put(TrackerActions.trackAction(moActionTypes.CREATE_MO.SUCCESS, mo.data));
      notification.open({
        type: 'success',
        message: ' Manufacturing Order successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(mo?.data);
      yield put(MOActions.createMOLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.createMOLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(MOActions.createMOLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.CREATE_MO.ERROR, error));
  }
}

/**
 *
 */
function* createMO() {
  yield takeLatest(moActionTypes.CREATE_MO.REQUEST, _createMO);
}

/**
 * @param action
 */
function* _createMOAdjustment(action) {
  try {
    yield put(MOActions.createMOAdjustmentLoading(true));
    const state = yield select();
    const isV2Enabled = state.UserReducers?.user?.tenant_info?.global_config?.settings?.enable_jw_v2;
    let moAdjustment;
    if(isV2Enabled) {
      moAdjustment = yield MOServices.createMOAdjustmentV2(action.payload);
    } else {
      moAdjustment = yield MOServices.createMOAdjustment(action.payload);
    }
    if (moAdjustment.success) {
      yield put(TrackerActions.trackAction(moActionTypes.CREATE_MO_ADJUSTMENT.SUCCESS, moAdjustment.data));
      action.callback(moAdjustment?.data?.[0]);
      yield put(MOActions.createMOAdjustmentLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: moAdjustment?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.createMOAdjustmentLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(MOActions.createMOAdjustmentLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.CREATE_MO_ADJUSTMENT.ERROR, error));
  }
}

/**
 *
 */
function* createMOAdjustment() {
  yield takeLatest(moActionTypes.CREATE_MO_ADJUSTMENT.REQUEST, _createMOAdjustment);
}

/**
 * @param action
 */
function* _updateMO(action) {
  try {
    yield put(MOActions.updateMOLoading(true));
    const mo = yield MOServices.updateMO(action.payload);
    if (mo.success) {
      yield put(TrackerActions.trackAction(moActionTypes.UPDATE_MO.SUCCESS, mo.data));
      notification.open({
        type: 'success',
        message: 'Manufacturing Order successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback(mo?.manufacturing_order);
      yield put(MOActions.updateMOLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.updateMOLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(MOActions.updateMOLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.UPDATE_MO.ERROR, error));
  }
}

/**
 *
 */
function* updateMO() {
  yield takeLatest(moActionTypes.UPDATE_MO.REQUEST, _updateMO);
}

/**
 * @param action
 */
function* _updateMOOtherCharges(action) {
  try {
    yield put(MOActions.updateMOOtherChargesLoading(true));
    const moOtherCharges = yield MOServices.updateMOOtherCharges(action.payload);
    if (moOtherCharges.success) {
      yield put(TrackerActions.trackAction(moActionTypes.UPDATE_MO_OTHER_CHARGES.SUCCESS, moOtherCharges.data));
      notification.open({
        type: 'success',
        message: 'Manufacturing Order successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback(moOtherCharges?.manufacturing_order);
      yield put(MOActions.updateMOOtherChargesLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: moOtherCharges?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.updateMOOtherChargesLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(MOActions.updateMOOtherChargesLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.UPDATE_MO_OTHER_CHARGES.ERROR, error));
  }
}

/**
 *
 */
function* updateMOOtherCharges() {
  yield takeLatest(moActionTypes.UPDATE_MO_OTHER_CHARGES.REQUEST, _updateMOOtherCharges);
}

/**
 * @param action
 */
function* _getMO(action) {
  try {
    MOActions.getMOSuccess(null);
    yield put(MOActions.getMOLoading(true));
    const {
      tenantId, moId, status, page, limit, searchKeyword, callback, sellerId, departmentId, fromDate, toDate, listScreen, isArchived, isWeightedAverage, scheduledStartDate, scheduledEndDate, isLinkedMrp, source, customerId, salesOrderNumber
    } = action;
    const mo = yield MOServices.getMO(tenantId, moId, status, page, limit, searchKeyword, sellerId, departmentId, fromDate, toDate, listScreen, isArchived, isWeightedAverage, scheduledStartDate, scheduledEndDate, isLinkedMrp, source, customerId, salesOrderNumber);
    yield put(MOActions.getMOSuccess(mo));
    if (callback) {
      callback(mo);
    }
    yield put(MOActions.getMOLoading(false));
  } catch (error) {
    yield put(MOActions.getMOLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_MO.ERROR, error));
  }
}

/**
 *
 */
function* getMO() {
  yield takeLatest(moActionTypes.GET_MO.REQUEST, _getMO);
}

/**
 * @param action
 */
function* _getMOById(action) {
  try {
    yield put(MOActions.getMOByIdLoading(true));
    const {
      tenantId, moId, costingMethod,
    } = action;
    const selectedMO = yield MOServices.getMO(tenantId, moId, '', '', '', '', '', '', '', '', false, '', ['fifo'].includes(costingMethod?.toLowerCase()));
    yield put(MOActions.getMOByIdSuccess(selectedMO?.result?.manufacturing_orders?.[0]));
    yield put(MOActions.getMOByIdLoading(false));
  } catch (error) {
    yield put(MOActions.getMOByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_MO_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getMOById() {
  yield takeLatest(moActionTypes.GET_MO_BY_ID.REQUEST, _getMOById);
}

/**
 * @param action
 */
function* _updateMOStatus(action) {
  try {
    yield put(MOActions.updateMOStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const mo = yield MOServices.updateMOStatus(payload);

    if (mo.success) {
      if (mo.manufacturing_order.status?.toLowerCase() === 'in_progress') {
        notification.open({
          type: 'success',
          message: ' Manufacturing Order in progress ',
          duration: 4,
          placement: 'top',
        });
      } else {
        notification.open({
          type: 'success',
          message: ' Manufacturing Order status  updated successfully',
          duration: 4,
          placement: 'top',
        });
      }

      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.updateMOStatusLoading(false));
  } catch (error) {
    yield put(MOActions.updateMOStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.UPDATE_STATUS_MO.ERROR, error));
  }
}

/**
 *
 */
function* updateMOStatus() {
  yield takeLatest(moActionTypes.UPDATE_STATUS_MO.REQUEST, _updateMOStatus);
}

/**
 * @param action
 */
function* _deleteMO(action) {
  try {
    yield put(MOActions.deleteMOLoading(true));
    const mo = yield MOServices.deleteMO(action.payload);

    if (mo.success) {
      notification.open({
        type: 'success',
        message: ' Manufacturing Order successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.deleteMOLoading(false));
  } catch (error) {
    yield put(MOActions.deleteMOLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.DELETE_MO.ERROR, error));
  }
}

/**
 *
 */
function* deleteMO() {
  yield takeLatest(moActionTypes.DELETE_MO.REQUEST, _deleteMO);
}

/**
 * @param action
 */
function* _archiveMo(action) {
  try {
    yield put(MOActions.archiveMoLoading(true));
    const mo = yield MOServices.archiveMo(action.payload);

    if (mo.success) {
      notification.open({
        type: 'success',
        message: 'Manufacturing Order successfully archived',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.archiveMoLoading(false));
  } catch (error) {
    yield put(MOActions.archiveMoLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.ARCHIVE_MO.ERROR, error));
  }
}

/**
 *
 */
function* archiveMo() {
  yield takeLatest(moActionTypes.ARCHIVE_MO.REQUEST, _archiveMo);
}

/**
 * @param action
 */
function* _updateMOAdjustmentStatus(action) {
  try {
    yield put(MOActions.updateMOAdjustmentStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const mo = yield MOServices.updateMOAdjustmentStatus(payload);

    if (mo.success) {
      notification.open({
        type: 'success',
        message: 'Batch status updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.updateMOAdjustmentStatusLoading(false));
  } catch (error) {
    yield put(MOActions.updateMOAdjustmentStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.UPDATE_MO_ADJUSTMENT_STATUS.ERROR, error));
  }
}

/**
 *
 */
function* updateMOAdjustmentStatus() {
  yield takeLatest(moActionTypes.UPDATE_MO_ADJUSTMENT_STATUS.REQUEST, _updateMOAdjustmentStatus);
}

function* _getMoJobWorks(action) {
  try {
    yield put(MOActions.getMoJobWorksLoading(true));
    const { payload, callback } = action;
    const jobWorks = yield MOServices.getMoJobWorks({
      mo_id: payload?.mo_id,
    });
    if (jobWorks.success) {
      if (callback) {
        callback();
      }
      yield put(MOActions.getMoJobWorksSuccess(jobWorks?.data));
    } else {
      notification.open({
        type: 'error',
        message: jobWorks.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.getMoJobWorksLoading(false));
  } catch (error) {
    yield put(MOActions.getMoJobWorksLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_MO_JOB_WORKS.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* getMoJobWorks() {
  yield takeLatest(moActionTypes.GET_MO_JOB_WORKS.REQUEST, _getMoJobWorks);
}

/**
 * @param action
 */
function* _getDownloadMO(action) {
  const {
    payload, callback,
  } = action;
  try {
    yield put(MOActions.getDownloadMOLoading(true));
    const moData = yield MOServices.getDownloadMO(payload?.type, payload?.emails, payload?.tenantId, payload?.status, payload?.searchKeyword, payload?.fromDate, payload?.toDate, payload?.sellerId, payload?.departmentId, payload?.isArchived, true, payload?.scheduledStartDate, payload?.scheduledEndDate, payload?.userId,  payload?.source, payload?.customerId, payload?.salesOrderNumber);
    if (moData?.success) {
      notification.open({
        type: 'success',
        message: 'Your request is being processed. You will receive the data on your email once ready.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: moData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.getDownloadMOLoading(false));
  } catch (error) {
    yield put(MOActions.getDownloadMOLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_DOWNLOAD_MO.ERROR, error));
  }
}

function* getDownloadMO() {
  yield takeLatest(moActionTypes.GET_DOWNLOAD_MO.REQUEST, _getDownloadMO);
}

/**
 * @param action
 */
function* _addRM(action) {
  try {
    yield put(MOActions.addRMLoading(true));
    const mo = yield MOServices.addRM(action.payload);
    if (mo.success) {
      yield put(TrackerActions.trackAction(moActionTypes.ADD_RM.SUCCESS, mo.data));
      notification.open({
        type: 'success',
        message: 'Added Raw Material Successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(mo?.data);
      }
      yield put(MOActions.addRMLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.addRMLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(MOActions.addRMLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.ADD_RM.ERROR, error));
  }
}

/**
 *
 */
function* addRM() {
  yield takeLatest(moActionTypes.ADD_RM.REQUEST, _addRM);
}

/**
 * @param action
 */
function* _removeRM(action) {
  try {
    yield put(MOActions.removeRMLoading(true));
    const mo = yield MOServices.removeRM(action.payload);
    if (mo.success) {
      yield put(TrackerActions.trackAction(moActionTypes.REMOVE_RM.SUCCESS, mo.data));
      notification.open({
        type: 'success',
        message: 'Removed Raw Material successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(mo?.data);
      } yield put(MOActions.removeRMLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.removeRMLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(MOActions.removeRMLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.REMOVE_RM.ERROR, error));
  }
}

/**
 *
 */
function* removeRM() {
  yield takeLatest(moActionTypes.REMOVE_RM.REQUEST, _removeRM);
}

/**
 * @param action
 */
function* _swapRM(action) {
  try {
    yield put(MOActions.swapRMLoading(true));
    const mo = yield MOServices.swapRM(action.payload);
    if (mo.success) {
      yield put(TrackerActions.trackAction(moActionTypes.SWAP_RM.SUCCESS, mo.data));
      notification.open({
        type: 'success',
        message: 'Removed Raw Material successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(mo?.data);
      } yield put(MOActions.swapRMLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.swapRMLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(MOActions.swapRMLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.SWAP_RM.ERROR, error));
  }
}

/**
 *
 */
function* swapRM() {
  yield takeLatest(moActionTypes.SWAP_RM.REQUEST, _swapRM);
}

function* _getWorkOrderRm(action) {
  try {
    MOActions.getWorkOrderRmSuccess(null);
    yield put(MOActions.getWorkOrderRmLoading(true));
    const { payload, callback } = action;
    const workOrderRm = yield MOServices.getWorkOrderRm(payload.moId, payload.fgTenantProductId);
    yield put(MOActions.getWorkOrderRmSuccess(workOrderRm));
    if (callback) {
      callback(workOrderRm?.data);
    }
    yield put(MOActions.getWorkOrderRmLoading(false));
  } catch (error) {
    yield put(MOActions.getWorkOrderRmLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_WORK_ORDER_RM.ERROR, error));
  }
}

function* getWorkOrderRm() {
  yield takeLatest(moActionTypes.GET_WORK_ORDER_RM.REQUEST, _getWorkOrderRm);
}

/**
 *
 */
export default function* moSaga() {
  yield all([
    createMO(), getMO(), updateMO(), getMOById(), updateMOStatus(),
    deleteMO(), archiveMo(), createMOAdjustment(), updateMOAdjustmentStatus(),
    updateMOOtherCharges(), getMoJobWorks(),
    getDownloadMO(), addRM(), removeRM(), swapRM(), getWorkOrderRm(),
  ]);
}
